export default __webpack_public_path__ + "static/media/voters_id.e4190caa.jpg";